import Headroom from 'headroom.js';

const Header = () => {

    let elem = document.querySelector(".header");
    let headerClass;
    let topClass;
    let pinnedClass = 'header--slideUp';
    let unpinnedClass = 'header--slideDown';

    let options = {
        "offset": 100,
        "tolerance": 0,
        "classes": {
            "initial": `${headerClass}`,
            "pinned": `${pinnedClass}`,
            "unpinned": `${unpinnedClass}`,
            "top": `${topClass}`,
        },

        onTop: function () {
            elem.classList.remove('header--slideUp');
        }
    }

    let headroom = new Headroom(elem, options);

    headroom.init();

    window.addEventListener('load', () => {
    document.body.classList.add('loaded');
    });

};

export default Header;